import React, { useContext, useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faEllipsisV,
  faExternalLinkAlt,
  faSort
} from "@fortawesome/free-solid-svg-icons";
import { AppDivisionContext } from "../../../../contexts/AppDivisionContext";
import { customDashboard } from "../../../../utils/api/dashboard";
import { Link } from "react-router-dom";
import Loading from "../../../Shared/ResourceIndex/Loading";
import DashboardContext from "../../../../contexts/DashboardContext";
import EllipsisPopover from '../../shared/EllipsisPopover/EllipsisPopover'




import { useTerminology } from "../../../../hooks/useTerminology";
const FindingsOverview = (props) => {
  const terms = useTerminology();
  const [search, setSearch] = useState('')
  const { getPath } = useContext(AppDivisionContext);
  const [clientIsAscending, setClientIsAscending] = useState(true)
  const [siteIsAscending, setSiteIsAscending] = useState(true)
  const { displayStatsForFO, isLoadingForFO, allProjectsForFO, setDisplayStatsForFO, setIsLoadingForFO, findingTypeListForFO } = useContext(DashboardContext)
  const widgetRef = useRef(0);
  const [widgetWidth, setWidgetWidth] = useState(widgetRef.current.clientWidth)
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    function handleResize() {
      setWidgetWidth(widgetRef.current.clientWidth)
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  })

  const handleSelect = (event) => {
    setIsLoadingForFO(true)
    customDashboard.fetchWithParams(getPath('/findingsOverview/getStats'), { "type": event.target.value })
      .then(res => {
        setDisplayStatsForFO(res.data.statistics)
        setIsLoadingForFO(false)
      })
      .catch((error) => console.log(error))
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  //SEARCH
  useEffect(() => {
    const updatedList = allProjectsForFO && [...allProjectsForFO].filter((el) => {
      return el.siteName.toLowerCase().includes(search.toLowerCase())
    })

    setDisplayStatsForFO(updatedList)
  }, [search])

  //SORT
  const sortBySiteName = () => {
    const updatedList = displayStatsForFO.sort((a, b) => {
      let A = a.siteName.toString().toLowerCase()

      let B = b.siteName.toString().toLowerCase()

      if (siteIsAscending === true) {
        setSiteIsAscending(!siteIsAscending)

        return A > B ? -1 : 1 // descending
      }

      else {
        setSiteIsAscending(!siteIsAscending)

        return A > B ? 1 : -1 //ascending
      }
    })

    setDisplayStatsForFO(updatedList)
  }

  const sortByClientName = () => {
    const updatedList = displayStatsForFO.sort((a, b) => {
      let A = a.clientName.toString().toLowerCase()

      let B = b.clientName.toString().toLowerCase()

      if (clientIsAscending === true) {
        setClientIsAscending(!clientIsAscending)

        return A > B ? -1 : 1 // descending
      }

      else {
        setClientIsAscending(!clientIsAscending)

        return A > B ? 1 : -1 //ascending
      }
    })

    setDisplayStatsForFO(updatedList)
  }


  let oneColumnHeader = {
    // gridTemplateAreas: '"title title title title . bars bars bars bars bars bars ellipsis"'
  }


  return (
    <>
      <div className="findings-overview" ref={widgetRef}>
        <header className="findings-overview__header" style={widgetWidth > 700 ? oneColumnHeader : null}>
          <h2 className="findings-overview__title">Findings Overview</h2>
          <div className="findings-overview__bars">
            <select name="finding-type" id="finding-type" placeholder="Select" onChange={(event) => handleSelect(event)}>
              <option value=" ">All Findings</option>
              {findingTypeListForFO.map((ele, index) => {
                return (
                  ele.name === "CA" ? <option value={ele.name} key={index}>Corrective Action</option> :
                    ele.name === "MI" ? <option value={ele.name} key={index}>Maintenance Item</option> :
                      <option value={ele.name} key={index}>{ele.name}</option>
                )
              })}
            </select>
            <input onChange={(event) => setSearch(event.target.value)} placeholder="Search" />
          </div>
          {/* <div className="findings-overview__ellipsis-button">
            <span onClick={(event) => setAnchorEl(event.currentTarget)}>
              <FontAwesomeIcon icon={faEllipsisV} />
            </span>
          </div> */}
          <EllipsisPopover handleCloseFunc={handleClose} id={id} open={open} anchorEl={anchorEl} />
        </header>

        <div
          data-rbd-drag-handle-context-id={props.providedProps}
          data-rbd-drag-handle-draggable-id="gibberish"
          style={{
            // When you set the data-rbd-drag-handle-context-id, RBD applies cursor: grab, so we need to revert that
            cursor: "auto"
          }}
        >
          <div className="findings-overview__body">
            <div className="findings-overview__content">
              <section>
                <section>
                  <div className="findings-overview__table-head">
                    <h3 onClick={sortBySiteName}>Site Name <span><FontAwesomeIcon icon={faSort} /></span></h3>
                    <h3 onClick={sortByClientName}>{terms.entity} Name <span><FontAwesomeIcon icon={faSort} /></span></h3>
                    <h3>Total Inspections </h3>
                    <h3>Average Findings per Inspection </h3>
                    <h3>Average Carry Over Findings per Inspection </h3>
                    <h3>Average Days to Correct </h3>
                    <h3>Max Days to Correct </h3>
                    <h3>Action</h3>
                  </div>

                  {
                    !isLoadingForFO ?
                      (displayStatsForFO && displayStatsForFO.map((ele, index) => {
                        return (
                          <div key={index} className="findings-overview__table-body">
                            <li>{ele.siteName}</li>
                            <li>{ele.clientName}</li>
                            <li>{ele.numberOfInspections}</li>
                            <li>{ele.averageFindings}</li>
                            <li>{ele.averageCarryOver}</li>
                            <li>{ele.averageDaysToCorrect}</li>
                            <li>{ele.maxDaysToCorrect}</li>
                            <li>
                              <Link to={`/divisions/${ele.divisionId}/projects/${ele.projectId}/inspections`}>
                                <span>View Project</span>
                              </Link>
                            </li>
                          </div>
                        )
                      })) :
                      (<Loading what="data" />)
                  }
                </section>
              </section>
            </div>

            <footer className="findings-overview__footer">
              <span onClick={props.changeShowMore}>Show {(props.mdSize === 6) ? 'More' : 'Less'} <FontAwesomeIcon icon={faExternalLinkAlt} /></span>
            </footer>
          </div>
        </div>
      </div>
    </>
  )
}


export default FindingsOverview